import Vue from 'vue';
import DialogComponent from '../components/shared/dialog-component.vue';

const DIALOG_PARAM = 'deleteUser';

class HomeDialog {
    constructor() {
        this.vm = this.createComponent();

        this.vm.$on('confirm', () => {
            this.vm.visible = false;
        });
    }

    createComponent() {
        const frag = document.createElement('div');
        document.body.appendChild(frag);

        return new Vue({
            components: {
                'dm-dialog': DialogComponent
            },
            template: `
                <dm-dialog v-if="visible"
                    v-on:confirm="$emit('confirm')"
                    v-on:cancel="$emit('cancel')"
                    title='Informacja'
                    :showCancelButton="showCancelButton"
                    :actionConfirmLabel="actionConfirmLabel">
                    <div class="_tac" data-t="7.10">
                        Twoje konto zostało usunięte!
                    </div>
                </dm-dialog>
            `,
            el: frag,
            data() {
                return {
                    visible: true,
                    showCancelButton: false,
                    actionConfirmLabel: 'ok'
                };
            }
        });
    }
}

if (DM.Utils.getParameterByName('dialog') === DIALOG_PARAM) {
    new HomeDialog();
}

export default HomeDialog;
